import { Typography } from '@navi/web-ui/lib/primitives';
import ToggleTabs from '@cp/src/components/toggleTabs/ToggleTabs';
import { tabOptions } from '@cp/src/pages/AgencyManagement/constants/constants';
import { isFunction } from '@cp/src/utils/commonUtils';
interface ActiveNextMonthWrapperProps {
  showActiveNextMonthToggle: boolean;
  isEditDisabled: boolean;
  isAgentActiveNextMonth: boolean;
  setIsAgentActiveNextMonth: (value: boolean) => void;
  isAgentActiveNextMonthToggleDirty: boolean;
  setIsAgentActiveNextMonthToggleDirty: (value: boolean) => void;
}
const ActiveNextMonthWrapper = (props: ActiveNextMonthWrapperProps) => {
  const {
    showActiveNextMonthToggle,
    isEditDisabled,
    isAgentActiveNextMonth,
    setIsAgentActiveNextMonth,
    isAgentActiveNextMonthToggleDirty,
    setIsAgentActiveNextMonthToggleDirty
  } = props;

  if (!showActiveNextMonthToggle) return <></>;

  const handleToggleTabChange = (value: string | boolean) => {
    if (isEditDisabled) return;
    setIsAgentActiveNextMonth(!isAgentActiveNextMonth);
    if (isFunction(setIsAgentActiveNextMonthToggleDirty)) {
      setIsAgentActiveNextMonthToggleDirty(!isAgentActiveNextMonthToggleDirty);
    }
  };

  return (
    <div className="flex justify-between pl-5 pr-8 mt-4 rounded-[8px]">
      <Typography
        variant="p4"
        color="var(--navi-bordered-input-label-text-color)"
        className="pt-1.5"
      >
        Active for next month
      </Typography>
      <ToggleTabs
        selected={isAgentActiveNextMonth}
        onTabClick={handleToggleTabChange}
        tabOptions={tabOptions}
        size="h6"
        tabClass="!m-0"
        containerClass="rounded-lg"
        isToggleDisabled={isEditDisabled}
      />
    </div>
  );
};

export default ActiveNextMonthWrapper;
